export const kapschFaultTreeDescriptions: Record<string, string> = {
  EVT_DM_FATAL_INCOMPLETE_FAST_OFF:
    'OBU repeatedly failed to switch off correctly when the battery protection mechanism was triggered.',
  EVT_GNSS_FATAL_COM_FAULT: 'OBU cannot communicate with the location (GNSS) hardware module.',
  EVT_LOC_FIX_PERSISTENT_FAULT:
    'OBU cannot get location information (GNSS fix) for more than 30 minutes.',
  EVT_CELL_PERSISTENT_CONNECTION_FAULT:
    'OBU cannot obtain a cellular connection for 24 hours, i.e., the unit operated for 24 hours without a data connection.',
  EVT_CELL_FATAL_COM_FAULT: 'OBU cannot communicate with the cellular (data) hardware module.',
  EVT_CELL_FATAL_SIM_FAULT:
    'OBU failed to read the SIM card data. ICCID cannot be read or persistent SIM card-related CME/CMS errors.',
  EVT_FG_FATAL_COM_FAULT:
    'OBU cannot communicate with the battery state supervision component (Fuel Gauge).',
  EVT_FG_FATAL_STATE_FAULT:
    'OBU battery state supervision component (Fuel Gauge) reported an operational unrecoverable fault.',
  EVT_FG_FATAL_BATTERY_FAULT:
    'OBU battery state supervision component (Fuel Gauge) cannot detect the battery.',
  EVT_CM_ITEM_FAILURE: 'The OBU update failed because of the update package content.',
  EVT_DSRC_UPDATE_FAILURE:
    'The OBU DSRC personalization failed because of the update file, causing an issue in the DSRC hardware module.',
  EVT_DSRC_FATAL_MEMORY_FAILURE:
    'OBU DSRC hardware module reported an internal fault and the FW error handling cannot resolve the issue.',
  EVT_DSRC_FATAL_COM_FAULT: 'OBU cannot communicate with the OBU DSRC hardware module.',
  EVT_PRM_DB_LOST:
    'OBU failed to access internal data and failed to restore the affected data on its own.',
  EVT_MEMS_FATAL_COM_FAULT:
    'OBU cannot communication with the motion sensor (accelerometer) hardware module. OBU error handling and recovery did not resolve the issue.',
  EVT_M2M_DM_CONNECTION_PERSIST_ERROR:
    'OBU failed to connect to the AssetManagement server for 24 hours, i.e., the unit operated for 24 hours without a connection to the back office.',
  EVT_NVRAM_FATAL_INTEGRITY_FAULT: 'OBU configuration content is affected.',
  EVT_SUBSCRIPTION_MISSING: 'OBU is in GNSS zone for which it does not have a subscription.',
  EVT_BLOCKED_OBU: 'OBU is in a blocked state (initiated by the central system).',
  EVT_ACTIVATION_SEQUENCE_COMPLETED: 'Customer accepted vehicle data',
  EVT_NO_CS_CONNECTION_PERSISTENT:
    'OBU failed failed to establish a connection to Proxy over a period of 24 hours, i.e., the unit operated for 24 hours without a connection to Proxy.',
  EVT_CONFLICTING_GNSS_PROVIDER: 'OBU is an overlapping GNSS toll domains which is not expected.',
};

export const kapschFaultTreeEventName: Record<number, string> = {
  24: 'EVT_DM_FATAL_INCOMPLETE_FAST_OFF',
  1008: 'EVT_GNSS_FATAL_COM_FAULT',
  2002: 'EVT_LOC_FIX_PERSISTENT_FAULT',
  3012: 'EVT_CELL_PERSISTENT_CONNECTION_FAULT',
  3016: 'EVT_CELL_FATAL_COM_FAULT',
  3018: 'EVT_CELL_FATAL_SIM_FAULT',
  4006: 'EVT_FG_FATAL_COM_FAULT',
  4008: 'EVT_FG_FATAL_STATE_FAULT',
  4010: 'EVT_FG_FATAL_BATTERY_FAULT',
  7014: 'EVT_CM_ITEM_FAILURE',
  9010: 'EVT_DSRC_UPDATE_FAILURE',
  9012: 'EVT_DSRC_FATAL_MEMORY_FAILURE',
  9014: 'EVT_DSRC_FATAL_COM_FAULT',
  10000: 'EVT_PRM_DB_LOST',
  11002: 'EVT_MEMS_FATAL_COM_FAULT',
  16002: 'EVT_M2M_DM_CONNECTION_PERSIST_ERROR',
  17002: 'EVT_NVRAM_FATAL_INTEGRITY_FAULT',
  50000: 'EVT_SUBSCRIPTION_MISSING',
  50010: 'EVT_BLOCKED_OBU',
  50019: 'EVT_ACTIVATION_SEQUENCE_COMPLETED',
  50020: 'EVT_NO_CS_CONNECTION_PERSISTENT',
  50028: 'EVT_CONFLICTING_GNSS_PROVIDER',
};
